import { type LevelConfiguration } from 'atoms/tournament';

const lc: LevelConfiguration = {
  allowBackdrawMovements: true,
  allowGeneratePlayOffForBackDraws: true,
  allowQualifyingDraws: true,
  allowSplitDraws: true,
  allowTeamSubstitutions: true,
  allowWildcards: true,
  doublesEventFormats: [],
  doublesScoreFormats: [],
  eventFormats: [],
  firstMatchLoserConsolation: true,
  goldSilverBronzeDrawsEnabled: true,
  ntrpEnabled: true,
  playTracker: true,
  rankingsEnabled: true,
  requireSafeplayApproval: true,
  scoreFormats: [],
  splitDrawEventFormats: ['RR', 'FICQ', 'CC', 'COMP', 'FIC16', 'FICSF', 'MFIC', 'KO', 'RRPO', 'FMLC', 'VC', 'FIC'],
  roundRobinPlayoffDrawEventFormats: ['COMP', 'RR', 'CC', 'FICQ', 'FIC16', 'FICSF', 'MFIC', 'KO', 'FIC', 'FMLC'],
  teamScoreFormats: [],
  wtnRankingsEnabled: true,
};
export default lc;
